import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  MdDashboard, MdArticle, MdAddCircle, MdCampaign, MdFlag,
  MdBarChart, MdSettings, MdLogout, MdMenu, MdClose, MdTune, MdComment
} from 'react-icons/md';

const navItems = [
  { path: '/', icon: MdDashboard, label: 'Dashboard' },
  // { path: '/articles/new', icon: MdAddCircle, label: 'Publish Article' },
  { path: '/articles', icon: MdArticle, label: 'Articles' },
  { path: '/manage', icon: MdTune, label: 'Categories & Cities' },
  { path: '/ads', icon: MdCampaign, label: 'Ads Manager' },
  { path: '/comments', icon: MdComment, label: 'Comments' },
  { path: '/moderation', icon: MdFlag, label: 'Moderation' },
  { path: '/analytics', icon: MdBarChart, label: 'Analytics' },
  { path: '/settings', icon: MdSettings, label: 'Settings' },
];

export default function Layout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      {/* Mobile header — sits outside .layout so it spans full width */}
      <header className="mobile-header">
        <button className="menu-btn" onClick={() => setSidebarOpen(true)}>
          <MdMenu />
        </button>
        <h1 className="logo-sm">Business Street</h1>
        <div className="admin-avatar-sm">{admin?.name?.charAt(0)}</div>
      </header>

      {/* Overlay */}
      {sidebarOpen && <div className="overlay" onClick={() => setSidebarOpen(false)} />}

      <div className="layout">
        {/* Sidebar */}
        <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="sidebar-header">
            <div>
              <h1 className="logo">Business Street</h1>
              <span className="logo-sub">Admin Panel</span>
            </div>
            <button className="close-btn" onClick={() => setSidebarOpen(false)}>
              <MdClose />
            </button>
          </div>

          <nav className="sidebar-nav">
            {navItems.map(({ path, icon: Icon, label }) => (
              <NavLink
                key={path}
                to={path}
                end={path === '/'}
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                onClick={() => setSidebarOpen(false)}
              >
                <Icon className="nav-icon" />
                <span>{label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="sidebar-footer">
            <div className="admin-info">
              <div className="admin-avatar">{admin?.name?.charAt(0)}</div>
              <div>
                <p className="admin-name">{admin?.name}</p>
                <p className="admin-email">{admin?.email}</p>
              </div>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <MdLogout /> Logout
            </button>
          </div>
        </aside>

        {/* Main content */}
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </>
  );
}
